import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { pageNotFoundDefaultData } from '@shared/constants/page-not-found-default-data';
import { PageNotFoundData } from '@shared/interfaces';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-page-not-found',
    standalone: true,
    imports: [TranslateModule, ButtonModule, FormsModule, NgOptimizedImage],
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent {
    pageNotFoundData!: PageNotFoundData;

    constructor(private router: Router) {
        const navigation = this.router.getCurrentNavigation();
        this.pageNotFoundData = (navigation?.extras.state as PageNotFoundData) ?? pageNotFoundDefaultData;
    }

    goToPreviousLink(): void {
        this.router.navigate([this.pageNotFoundData.previousLink]);
    }

    openChat(): void {
        // @ts-ignore
        window['happyFoxChat'].showWidget();
        // @ts-ignore
        window['happyFoxChat'].expandChatbox();
    }
}
